import request from '@/utils/request';
import type { ApiResponse } from '@/types';
import type { SuggestionItem } from '@/types/admin';

/** 建议反馈 API */
export const suggestionAPI = {
  /** 提交建议 */
  create: (data: { content: string }): Promise<ApiResponse<SuggestionItem>> =>
    request.post('/suggestion/create', data) as Promise<ApiResponse<SuggestionItem>>,

  /** 获取建议列表（分页/搜索，需登录） */
  getList: (params: { keyword?: string; page?: number; pageSize?: number }): Promise<ApiResponse<{ list: SuggestionItem[]; total: number }>> =>
    request.get('/suggestion/list', { params }) as Promise<ApiResponse<{ list: SuggestionItem[]; total: number }>>,

  /** 删除建议（需登录） */
  delete: (id: number): Promise<ApiResponse<null>> =>
    request.post('/suggestion/delete', { id }) as Promise<ApiResponse<null>>,
};
